// extracted by mini-css-extract-plugin
export var externalLink = "_bh-0";
export var internalLinkLabel = "_bh-1";